import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetGames } from '../../../store/games/thunk/setGetGames';
import GameItem from './components/GameItem';
import InfiniteScroll from 'react-infinite-scroll-component';

const GamesList = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    const handleClick = () => {
        router.history.push('/games/create')
    }

    const fetchMoreData = () => {
        alert('Загрузка')
    };

    React.useEffect(() => {
        dispatch(setGetGames({
            page: 1,
            pageSize: 50,
        }));
    }, []);

    const items = useSelector((state) => state.games.list);

    return (
        <div style={{ padding: '0 20px' }}>
            <Title
                label="Список игр"
                labelBtn="Добавить игру"
                button={handleClick}
            />
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {
                    items?.data?.map((item) => (
                        <GameItem {...item} />
                    ))
                }
            </div>
        </div>
    )
}

export default GamesList;